import {useMutation} from '@apollo/client';
import {DELETE_CART} from "../productTypeDefs";

export const useMutationDeleteCart = (options?: any): any => (
  useMutation(DELETE_CART, options)
);
